<template>
  <div class="ledger-page">
    <b-card class="rounded-lg">
      <h4 class="mb-1">{{ $t('ledger_rep_mine') }}</h4>
      <div class="d-flex mb-1">
        <b-button class="mr-50 rounded-pill" :variant="mode === 'day' ? 'primary' : 'outline-primary'" @click="mode = 'day'; load()">
          {{ $t('ledger_rep_day') }}
        </b-button>
        <b-button class="rounded-pill" :variant="mode === 'month' ? 'primary' : 'outline-primary'" @click="mode = 'month'; load()">
          {{ $t('ledger_payroll_month') }}
        </b-button>
      </div>
      <div v-if="mode === 'day'" class="mb-1">
        <b-form-input v-model="date" type="date" class="ledger-report-date" @change="load" />
      </div>
      <div v-else class="d-flex mb-1">
        <b-form-input v-model.number="year" type="number" class="mr-50 ledger-report-year" />
        <b-form-input v-model.number="month" type="number" min="1" max="12" class="ledger-report-year" @change="load" />
      </div>
      <div v-if="loading" class="text-center py-3"><b-spinner /></div>
      <template v-else-if="report">
        <h5>{{ report.user && report.user.name }}</h5>
        <b-card v-if="report.custody && report.custody.totals" class="mb-1">
          <div>{{ $t('ledger_rep_custody') }}</div>
          <strong class="ledger-num">{{ money(report.custody.totals.current_balance) }}</strong>
        </b-card>
        <h6>{{ $t('ledger_rep_transactions') }}</h6>
        <article v-for="item in (report.transactions && report.transactions.items) || []" :key="item.id" class="ledger-report-card">
          {{ item.transaction_number }}
          <span class="ledger-num">{{ money(item.amount) }}</span>
        </article>
        <h6 class="mt-1">{{ $t('ledger_payslip_title') }}</h6>
        <article v-for="slip in report.payslips || []" :key="slip.payroll_run_id" class="ledger-report-card">
          <b-link :to="{ name: 'me-payslip-view', params: { id: slip.payroll_run_id } }">
            {{ slip.year }}/{{ slip.month }}
          </b-link>
          <span class="ledger-num"> {{ money(slip.net) }}</span>
        </article>
      </template>
    </b-card>
  </div>
</template>

<script>
import { BCard, BButton, BFormInput, BSpinner, BLink } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getMyDailyReport, getMyMonthlyReport } from '@/api/accounting/financialReports'
import { oneFrom, formatLedgerMoney, todayIso, apiErrorMessage } from '@/utils/ledger'

export default {
  name: 'MyReports',
  components: { BCard, BButton, BFormInput, BSpinner, BLink },
  data() {
    const now = new Date()
    return {
      mode: 'day',
      date: todayIso(),
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      loading: false,
      report: null,
    }
  },
  mounted() { this.load() },
  methods: {
    money(value) {
      return formatLedgerMoney(value || 0, this.$i18n.locale)
    },
    async load() {
      this.loading = true
      try {
        const res = this.mode === 'day'
          ? await getMyDailyReport({ date: this.date })
          : await getMyMonthlyReport({ year: this.year, month: this.month })
        this.report = oneFrom(res)
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: { title: apiErrorMessage(error, this.$t('ledger_error')), icon: 'AlertCircleIcon', variant: 'danger' },
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ledger-num { font-variant-numeric: tabular-nums; }
.ledger-report-date { max-width: 12rem; }
.ledger-report-year { max-width: 7rem; }
.ledger-report-card { border-bottom: 1px solid #eee; padding: 0.6rem 0; }
</style>
